import React, { useState, useEffect } from 'react'
import { Button } from 'semantic-ui-react'
import CodeMirror from '@uiw/react-codemirror'
import { javascript } from '@codemirror/lang-javascript'

const ComponentInspector = ({ children }) => {
  const [showSidebar, setShowSidebar] = useState(false)
  const [selectedInfo, setSelectedInfo] = useState(null)
  const [fileContent, setFileContent] = useState('')
  const findOwnerWithSource = (fiber) => {
    let current = fiber
    while (current) {
      if (current._debugSource) return current
      current = current._debugOwner
    }
    return null
  }
  const readFileContent = async (filepath) => {
    try {
      const response = await fetch(
        `/readFile?path=${encodeURIComponent(filepath)}`
      )
      const content = await response.text()
      setFileContent(content)
    } catch (error) {
      console.error(error)
      setFileContent('Error reading file content')
    }
  }

  const saveFileContent = async (filepath, content) => {
    try {
      await window.fs.writeFile(filepath, content)
    } catch (error) {
      console.error('Error saving file:', error)
    }
  }

  useEffect(() => {
    const handleClick = (e) => {
      if (e.metaKey || e.ctrlKey) {
        e.preventDefault()

        const element = e.target
        const key = Object.keys(element).find(
          (key) =>
            key.startsWith('__reactFiber$') ||
            key.startsWith('__reactInternalInstance$')
        )

        if (element && key) {
          const fiber = element[key]
          const ownerFiber = findOwnerWithSource(fiber)

          if (ownerFiber) {
            const componentName =
              ownerFiber.elementType?.displayName ||
              ownerFiber.type?.displayName ||
              ownerFiber.elementType?.name ||
              (typeof ownerFiber.type === 'function'
                ? ownerFiber.type.name
                : '') ||
              ownerFiber.type ||
              'Unknown'

            const fileInfo = {
              component: componentName,
              file: ownerFiber._debugSource.fileName,
              line: ownerFiber._debugSource.lineNumber,
            }

            setSelectedInfo(fileInfo)
            readFileContent(fileInfo.file)
            setShowSidebar(true)
          }
        }
      }
    }

    document.addEventListener('click', handleClick)
    return () => document.removeEventListener('click', handleClick)
  }, [])

  if (process.env.NODE_ENV !== 'development') {
    return children
  }
  return (
    <div>
      <div
        className="ui sidebar inverted left overlay visible"
        style={{
          zIndex: 100000,
          display: showSidebar ? 'block' : 'none',
          width: '600px',
          padding: '2rem',
          backgroundColor: 'white',
          color: 'black',
          boxShadow: '0 0 10px rgba(0,0,0,0.1)',
        }}
      >
        <div className="ui header">
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '1rem',
            }}
          >
            Component Inspector
            <i
              className="close icon"
              onClick={() => setShowSidebar(false)}
              style={{ cursor: 'pointer' }}
            />
          </div>
        </div>

        {selectedInfo && (
          <div className="ui segments">
            <div className="ui segment">
              <h4 className="ui header">Component</h4>
              <p>{selectedInfo.component}</p>
            </div>

            <div className="ui segment">
              <h4 className="ui header">File</h4>
              <p>{selectedInfo.file}</p>
            </div>

            <div className="ui segment">
              <h4 className="ui header">Line</h4>
              <p>{selectedInfo.line}</p>
            </div>
            <div className="ui segment">
              <h4 className="ui header">Open</h4>
              <p>
                <Button
                  href={`vscode://file${selectedInfo.file}`}
                  style={{ marginLeft: '10px' }}
                >
                  Open in VS Code
                </Button>
                <Button
                  href={`ghostty://neovim ${selectedInfo.file}`}
                  style={{ marginLeft: '10px' }}
                >
                  Open in Neovim
                </Button>
              </p>
            </div>
            {/* <div className="ui segment" style={{ height: '500px' }}> */}
            {/* <CodeMirror */}
            {/*   value={fileContent} */}
            {/*   height="100%" */}
            {/*   theme="dark" */}
            {/*   extensions={[javascript()]} */}
            {/*   onChange={(value) => { */}
            {/*     setFileContent(value); */}
            {/*     saveFileContent(selectedInfo.file, value); */}
            {/*   }} */}
            {/*   options={{ */}
            {/*     lineNumbers: true, */}
            {/*     tabSize: 2, */}
            {/*   }} */}
            {/* /> */}
            {/* </div> */}
          </div>
        )}
      </div>

      {children}
    </div>
  )
}

export default ComponentInspector
